<section class="mbd-page">
  <div class="mbd-container">

    <!-- ===== TAB STRIP ===== -->
    <div class="mbd-s3-tabs">
      <button class="mbd-s3-tab" [class.active]="activeTab==='compliance'" (click)="setTab('compliance')">Compliance</button>
      <button class="mbd-s3-tab" [class.active]="activeTab==='meetings-board'" (click)="setTab('meetings-board')">Meetings &amp; board</button>
      <button class="mbd-s3-more"><i class="fa fa-ellipsis-h"></i></button>
    </div>

    <!-- ===== HEADER STRIP ===== -->
    <div class="mbd-s3-header">
      <div class="mbd-s3-header-left">
        <div class="mbd-s3-header-label">Meetings &amp; board management</div>
        <div class="mbd-s3-header-title">{{currentPeriod}} · {{companyName}}</div>
      </div>
      <button class="mbd-btn-primary" (click)="scheduleMeeting()">+ Schedule meeting</button>
    </div>

    <!-- ===== HERO KPI STAT CARDS ===== -->
    <div class="mbd-stat-cards">
      <div class="mbd-stat-card">
        <div class="mbd-stat-nums"><span class="mbd-stat-val">8</span><span class="mbd-stat-denom"> / 12 planned</span></div>
        <div class="mbd-stat-label">Meetings this quarter</div>
        <div class="mbd-stat-sub">1 board · 3 audit · 2 NRC · 2 CSR</div>
        <div class="mbd-stat-bar"><div class="mbd-stat-bar-fill" style="width:67%"></div></div>
      </div>
      <div class="mbd-stat-card">
        <div class="mbd-stat-nums"><span class="mbd-stat-val">1</span><span class="mbd-stat-denom"> / 4 required</span></div>
        <div class="mbd-stat-label">Board meetings FY27</div>
        <div class="mbd-stat-bar"><div class="mbd-stat-bar-fill" style="width:25%"></div></div>
      </div>
      <div class="mbd-stat-card">
        <div class="mbd-stat-nums"><span class="mbd-stat-val">53</span><span class="mbd-stat-denom"> / 120 max</span></div>
        <div class="mbd-stat-label">Days since last board</div>
        <div class="mbd-stat-bar"><div class="mbd-stat-bar-fill ok" style="width:44%"></div></div>
      </div>
      <div class="mbd-stat-card">
        <div class="mbd-stat-nums"><span class="mbd-stat-val">23</span></div>
        <div class="mbd-stat-label">Action items open</div>
        <div class="mbd-stat-sub">5 due this wk</div>
        <div class="mbd-stat-sub">From 6 past meetings</div>
      </div>
    </div>

    <!-- ===== ALL MEETINGS TIMELINE ===== -->
    <div class="mbd-timeline-card mbd-card">
      <div class="mbd-timeline-header">
        <span class="mbd-timeline-title">All meetings · FY27</span>
        <div class="mbd-timeline-legend">
          <span class="mbd-dot board"></span>Board
          <span class="mbd-dot audit"></span>Audit
          <span class="mbd-dot nrc"></span>NRC
          <span class="mbd-dot src"></span>SRC
          <span class="mbd-dot csr"></span>CSR
          <span class="mbd-dot risk"></span>Risk
        </div>
      </div>
      <div class="mbd-timeline-body">
        <div class="mbd-tl-month"
             *ngFor="let m of allMeetingsTimeline"
             [class.current]="m.current"
             [class.past]="m.past">
          <div class="mbd-tl-dots">
            <span *ngFor="let d of m.dots" class="mbd-dot" [class]="'mbd-dot ' + d"></span>
            <span *ngIf="!m.dots.length && !m.past" class="mbd-tl-plus"
                  [class.warn]="m.warn">
              <i class="fa" [class.fa-plus]="!m.warn" [class.fa-exclamation]="m.warn"></i>
            </span>
          </div>
          <div class="mbd-tl-label" [class.warn]="m.warn">
            {{m.month}}<span *ngIf="m.warn"> ⚠</span>
          </div>
        </div>
      </div>
      <div class="mbd-timeline-hint">Click any month to schedule · faded dots are past meetings · outlined dot is scheduled</div>
    </div>

    <!-- ===== COMPLIANCE WIDGET (meeting type tabs + quarterly cards + gap) ===== -->
    <div class="mbd-card mbd-compliance-outer">

      <!-- Meeting type tabs -->
      <div class="mbd-mt-tabs">
        <button *ngFor="let tab of meetingTypeTabs"
                class="mbd-mt-tab"
                [class.active]="activeMeetingType === tab.key"
                (click)="setMeetingType(tab.key)">
          {{tab.label}}
        </button>
      </div>

      <!-- Compliance title + rule + status -->
      <div class="mbd-compliance-header">
        <span class="mbd-compliance-title">{{activeCompliance.title}}</span>
        <div class="mbd-compliance-meta">{{activeCompliance.rule}}</div>
        <span class="mbd-badge" [class]="'mbd-badge-' + activeCompliance.statusClass">{{activeCompliance.statusLabel}}</span>
      </div>

      <!-- Quarterly cards -->
      <div class="mbd-compliance-quarters">
        <div class="mbd-q-card"
             *ngFor="let q of activeCompliance.quarters"
             [class.ok]="q.state==='ok'"
             [class.urgent]="q.state==='urgent'"
             [class.pending]="q.state==='pending'">
          <div class="mbd-q-top">
            <span class="mbd-q-label">{{q.q}}</span>
            <span class="mbd-q-period">{{q.period}}</span>
          </div>
          <div class="mbd-q-content">
            <div class="mbd-q-detail">{{q.primary}}</div>
            <div class="mbd-q-note">{{q.secondary}}</div>
            <div class="mbd-q-note2" *ngIf="q.note !== '—'">{{q.note}}</div>
          </div>
          <button *ngIf="q.action" class="mbd-q-schedule-btn" (click)="scheduleMeeting()">+ Schedule</button>
        </div>
      </div>

      <!-- Gap section -->
      <div class="mbd-gap-top">
        <div class="mbd-gap-left">
          <div class="mbd-gap-title">{{activeCompliance.gap.title}}</div>
          <div class="mbd-gap-subtitle">{{activeCompliance.gap.subtitle}}</div>
        </div>
        <div class="mbd-gap-right">
          <div class="mbd-gap-count">
            <span class="mbd-gap-num">{{activeCompliance.gap.current}}</span>
            <span class="mbd-gap-denom">/ {{activeCompliance.gap.max}} days</span>
          </div>
          <div class="mbd-gap-rem">{{activeCompliance.gap.remaining}} days remaining</div>
        </div>
      </div>

      <div class="mbd-progress-wrap">
        <div class="mbd-progress-track">
          <div class="mbd-progress-fill"
               [class.warn]="gapFillClass==='warn'"
               [class.breach]="gapFillClass==='breach'"
               [style.width.%]="gapFillPct"></div>
          <div class="mbd-progress-warn-line" [style.left.%]="gapWarnPct"></div>
        </div>
        <div class="mbd-progress-labels">
          <span>0</span>
          <span class="mbd-pl-warn">warn</span>
          <span class="mbd-pl-breach">{{activeCompliance.gap.max}} · breach</span>
        </div>
      </div>

      <div class="mbd-gap-dates">
        <div class="mbd-gap-date-col">
          <div class="mbd-gap-date-label">SCHEDULE BY</div>
          <div class="mbd-gap-date-val" [class.breach]="activeCompliance.gap.urgent">{{activeCompliance.gap.scheduleBy}}</div>
        </div>
        <div class="mbd-gap-date-col">
          <div class="mbd-gap-date-label">SUGGESTED TARGET</div>
          <div class="mbd-gap-date-val">{{activeCompliance.gap.suggested}}</div>
        </div>
        <div class="mbd-gap-date-col">
          <div class="mbd-gap-date-label">NEXT SCHEDULED</div>
          <div class="mbd-gap-date-val mbd-scheduled">{{activeCompliance.gap.nextScheduled}}</div>
        </div>
      </div>

      <!-- Weekend rule notice -->
      <div class="mbd-weekend-notice">
        <i class="fa fa-clock-o"></i>
        Weekend rule active. Meetings scheduled on Sat/Sun are auto-preponed to Friday. 2 upcoming meetings affected this quarter.
      </div>
    </div>

    <!-- ===== CALENDAR + COMMITTEE FREQUENCY ===== -->
    <div class="mbd-cal-committee-row">

      <!-- Calendar -->
      <div class="mbd-card mbd-calendar-card">
        <div class="mbd-cal-header">
          <span class="mbd-cal-month-label">June 2026</span>
          <div class="mbd-cal-legend">
            <span class="mbd-dot board"></span><span>Board</span>
            <span class="mbd-dot audit"></span><span>Audit</span>
            <span class="mbd-dot nrc"></span><span>NRC</span>
          </div>
        </div>
        <div class="mbd-cal-grid">
          <div class="mbd-cal-weekday" *ngFor="let d of ['SUN','MON','TUE','WED','THU','FRI','SAT']">{{d}}</div>
          <div class="mbd-cal-cell"
               *ngFor="let cell of calendarCells"
               [class.other-month]="cell.prevMonth || cell.nextMonth"
               [class.today]="!cell.prevMonth && !cell.nextMonth && cell.day === 20">
            <span class="mbd-cal-day">{{cell.day}}</span>
            <ng-container *ngIf="!cell.prevMonth && !cell.nextMonth && calendarMeetings[cell.day]">
              <div class="mbd-cal-events">
                <span *ngFor="let ev of calendarMeetings[cell.day]"
                      class="mbd-cal-event"
                      [class]="'mbd-cal-event ' + ev.type">
                  <span *ngIf="ev.preponed" class="mbd-preponed">↵</span>{{ev.label}}
                </span>
              </div>
            </ng-container>
          </div>
        </div>
        <div class="mbd-cal-footer">↵ Auto-preponed from weekend</div>
      </div>

      <!-- Committee meeting frequency -->
      <div class="mbd-card mbd-committee-card">
        <div class="mbd-committee-title">Committee meeting frequency</div>
        <div class="mbd-committee-sub">Frequency &amp; gap from committee master · FY27</div>
        <div class="mbd-committee-list">
          <div class="mbd-committee-row" *ngFor="let item of committeeFrequency">
            <div class="mbd-committee-name-row">
              <span class="mbd-committee-name">{{item.name}}</span>
              <span class="mbd-committee-stat" [class.breach]="item.status==='breach'">
                {{item.held}} / {{item.required}} · {{item.gap}}
              </span>
            </div>
            <div class="mbd-committee-bar-track">
              <div class="mbd-committee-bar-fill"
                   [class.breach]="item.status==='breach'"
                   [class.warn]="item.status==='warn'"
                   [style.width.%]="(item.held / item.required) * 100">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ===== ACTION ITEMS FOLLOW-THROUGH ===== -->
    <div class="mbd-card mbd-action-items">
      <div class="mbd-ai-header">
        <span class="mbd-ai-title">Action items follow-through</span>
        <span class="mbd-ai-sub">From last 6 meetings</span>
      </div>
      <div class="mbd-ai-list">
        <div class="mbd-ai-row" *ngFor="let item of actionItems"
             [style.border-left]="'3px solid ' + item.accentColor">
          <div class="mbd-ai-left">
            <div class="mbd-ai-text">
              <div class="mbd-ai-item-title">{{item.title}}</div>
              <div class="mbd-ai-item-source">From {{item.source}}</div>
            </div>
          </div>
          <div class="mbd-ai-right">
            <span class="mbd-ai-status" [class]="'mbd-ai-status ' + item.status">{{item.statusLabel}}</span>
            <div class="mbd-ai-avatar"
                 [style.background]="item.avatarBg"
                 [style.color]="item.avatarColor">{{item.initials}}</div>
          </div>
        </div>
      </div>
      <div class="mbd-ai-more">
        <button class="mbd-ai-more-btn"><i class="fa fa-chevron-down"></i></button>
      </div>
    </div>

    <!-- ===== QUICK ACTIONS (BOTTOM) ===== -->
    <div class="mbd-quick-actions">
      <span class="mbd-qa-label">Quick actions</span>
      <div class="mbd-qa-btns">
        <button class="mbd-qa-btn" (click)="scheduleMeeting()">+ Schedule meeting</button>
        <button class="mbd-qa-btn" (click)="draftAgenda()">Draft agenda</button>
        <button class="mbd-qa-btn" (click)="uploadBoardPack()">Upload board pack</button>
        <button class="mbd-qa-btn" (click)="generateMinutes()">Generate minutes</button>
      </div>
    </div>

  </div>
</section>
